import ModalContainer from "../ModalContainer/ModalContainer"
import { AiOutlineClose } from "react-icons/ai"
import { useState } from "react"

const CustomAmountInput = ({ closeModal, handleSuccess, maxAmount }) => {
  const [amount, setAmount] = useState(null)

  console.log(maxAmount, parseInt(amount))

  const handleSubmit = e => {
    e.preventDefault()
    localStorage.setItem("checkout", JSON.stringify({ amount: amount }))
    handleSuccess()
  }

  const checkAmount = () => {
    while (parseInt(amount) > maxAmount) {
      return false
    }
    if (amount > 0) {
      return true
    } else {
      return false
    }
  }

  return (
    <ModalContainer>
      <div className="py-3 px-5 w-96  bg-white">
        <AiOutlineClose
          className="text-3xl font-bold ml-auto mb-3 cursor-pointer"
          onClick={() => closeModal()}
        />
        <form onSubmit={handleSubmit}>
          <h3 className="text-sbg-grey text-lg mb-2">Gift amount </h3>
          <input
            className="bg-gray-200 block w-full  py-3 px-6 my-2"
            name="name"
            onChange={e => setAmount(e.target.value)}
            placeholder="Amount to gift"
            required
            value={amount}
            type="number"
          />

          <button
            type="submit"
            disabled={!checkAmount()}
            className={`mx-auto px-5 block py-2 text-center text-white bg-sbg-light-green font-medium text-base focus:outline-none my-5 ${
              !checkAmount() && "btn-disabled"
            }`}
          >
            Proceed
          </button>
        </form>
      </div>
    </ModalContainer>
  )
}

export default CustomAmountInput
